import React, { FunctionComponent } from 'react'

import { AliasesCSSProperties } from '@styled-system/css'
import { Box, Flex } from '@theme-ui/components'
import { ThemeUIStyleObject } from 'theme-ui'

import { Sidebar } from 'features/sidebar/Sidebar'

type LayoutProps = {
  dark?: boolean
  hideSidebar?: boolean
  maxContentWidth?: number
  px?: AliasesCSSProperties['px']
  contentSx?: ThemeUIStyleObject
  children?: React.ReactNode
}

export const Layout: FunctionComponent<LayoutProps> = ({
  dark,
  maxContentWidth = 1200,
  px = 10,
  contentSx,
  children,
  hideSidebar,
}) => (
  <Flex
    sx={{
      height: '100vh',
    }}
  >
    {!hideSidebar && (
      <Box sx={{ flex: '0 0 auto' }} className="box-sidebar">
        <Sidebar />
      </Box>
    )}

    <Box
      sx={{
        bg: dark ? 'grey100' : 'white',
        minHeight: '100vh',
        overflowY: 'auto',
        flex: '1 1 auto',
      }}
      className="Layout-scroller"
    >
      <Box
        sx={{
          // @ts-ignore
          maxWidth: th => maxContentWidth + th.space[20],
          px,
          pt: 8,
          pb: 20,
          m: 'auto',
          ...contentSx,
        }}
      >
        {children}
      </Box>
    </Box>
  </Flex>
)
